import { useState } from "react";
import { useSelector } from "react-redux";

import { CheckoutGiftCardForm } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/giftCardPayment/giftCardForm.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import {
    APIStatus,
    addCoupon,
    removeCoupon
} from "@/redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as PaymentMethodsModule from "@/redux/modules/api/data/checkout/paymentMethods/paymentMethods.module";
import { PromotionTypes } from "@/utils/enums";

import { CheckoutGiftCardFormValues } from "./giftCardForm.schema";

const GiftCardPaymentContainer = () => {
    const dispatch = useThunkDispatch();
    const [code, setCode] = useState("");
    const [giftCardErrorMessage, setGiftCardErrorMessage] = useState(null);
    const isCartloading = useSelector(CartSelectors.isLoading);
    const cart = useSelector(CartSelectors.getCart);

    const onSubmitGiftCardHandler = (
        formValues: CheckoutGiftCardFormValues,
        resetFormCallback: () => void
    ) => {
        setGiftCardErrorMessage(null);

        dispatch(
            addCoupon(
                {
                    code: formValues.cardCode,
                    recaptcha: formValues.recaptcha,
                    bonusCardNumber: formValues.bonusCard?.number
                },
                true
            )
        )
            .then((action) => {
                if (action.type === APIStatus.SUCCESS) {
                    resetFormCallback();
                    dispatch(PaymentMethodsModule.load());
                } else {
                    setGiftCardErrorMessage(action.payload.error.response.data);
                }
            })
            .finally(() => {
                setCode(formValues.cardCode);
            });
    };

    const onDeleteGiftCardHandler = (cardCode: string) => {
        return dispatch(removeCoupon(cardCode)).then((action) => {
            if (action.type === APIStatus.SUCCESS) {
                setGiftCardErrorMessage(null);
                dispatch(PaymentMethodsModule.load());
            } else {
                setGiftCardErrorMessage(action.payload.error.response.data);
            }
        });
    };

    const giftCardPayments =
        cart?.giftCardPayments.map((giftCard) => ({
            cardNumber: giftCard.cardNumber
        })) || [];
    const promotionCodes =
        cart?.promotionCodes
            .filter((promotion) => promotion.type !== PromotionTypes.PROMOTION)
            .map((promotion) => ({ cardNumber: promotion.code })) || [];

    const coupons = giftCardPayments.concat(promotionCodes);

    return (
        <CheckoutGiftCardForm
            onSubmit={onSubmitGiftCardHandler}
            onDelete={onDeleteGiftCardHandler}
            renderInput={cart?.totalPrice !== 0}
            errorMessage={giftCardErrorMessage}
            code={code}
            giftCardList={coupons}
            isLoading={isCartloading}
        />
    );
};

export default GiftCardPaymentContainer;
